import {API_ROOT_URL} from 'envs/_current/config'
import {createAsyncAction} from 'modules/asyncCache'
import {schema} from 'normalizr'
import {baseFieldTypes} from './base/baseFieldTypes'
import {channelSchema, groupSchema, organizationSchema, userSchema} from './schema'
import {eventSchema} from './schema/event'
import {createTransform} from './utils/createTransform'
import {musicSchema} from './music'

export const followSchema = new schema.Union(
    {
        organization: organizationSchema,
        group: groupSchema,
        channel: channelSchema,
        user: userSchema,
        event: eventSchema,
        music: musicSchema,
    },
    '_type'
)

const fields = ['owner_type', 'owner_id']

const fieldTypes = {
    owner_id: baseFieldTypes.string,
    owner_type: ['user', 'organization', 'channel'],
}
const transform = createTransform(followSchema, 'data')
// Route::post('auth/following/add', 'FollowController@add');
export const follow_add_Api = {
    backend: ` Route::post('auth/following/add', 'FollowController@add');`,
    root: API_ROOT_URL,
    path: '/auth/following/add',
    method: 'POST',
    fields,
    fieldTypes,
    transform,
}
export const create_follow_add_Api_action =
    () =>
        ({prefixStr = 'follow_add_Api', query, values, maxAge = -1}) =>
            createAsyncAction({
                prefixStr: prefixStr + '@follow_add_Api',
                query,
                values,
                apiInfo: follow_add_Api,
                maxAge,
            })

// Route::post('auth/following/remove', 'FollowController@remove');
export const follow_remove_Api = {
    backend: `Route::post('auth/following/remove', 'FollowController@remove')`,
    root: API_ROOT_URL,
    path: '/auth/following/remove',
    method: 'POST',
    fields,
    fieldTypes,
    transform,
}
export const create_follow_remove_Api_action =
    () =>
        ({prefixStr = 'follow_remove_Api', query, values, maxAge = -1}) =>
            createAsyncAction({
                prefixStr: prefixStr + '@follow_remove_Api',
                query,
                values,
                apiInfo: follow_remove_Api,
                maxAge,
            })
